import { styled } from "@mui/material/styles";

export const DialogueStyled = styled("div")(({ theme }) => ({
  "& .labelSwitch": {
    borderRadius: "10px",
    height: "60px",
    background: "#EAF6FF",
    padding: "0 0 0 10px",
    paddingBottom: "0 !important",
    display: "flex",
    alignItems: "center",
    fontFamily: "Poppins",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
  },
  "& .list": {
    fontSize: "16px",
    fontWeight: "500",
    padding: "12px",
    fontFamily: "Poppins",
    alignItem: "center",
    margin: "10px",
  },
  "& .userPassword": {
    position: "relative",
  },
  "& svg.eyaIcon": {
    cursor: "pointer",
  },
  "& .add": {
    margin: "12px 0",
    display: "flex",
  },
  "& .clear": {
    margin: "0.5rem 0",
  },
  "& .frequency": {
    color: " #1F4970",
    margin: "10px 2px",
    fontSize: " 14px",
    fontWeight: "600",
    textTransform: " capitalize",
  },
  "& .createShift": {
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "15px",
    overflowY: "auto",
    maxHeight: "90vh",
    margin: "0px 10px",
    fontFamily: "Poppins",
    zIndex: "9999",
  },
  "& .Visit": {
    display: "flex",
    margin: "10px 0px",
  },

  "& .upload": {
    background: "rgba(216, 222, 233, 0.2);",
    height: "224px",
    borderRadius: "10px",
    margin: "10px 0px",
    border: "2px dashed #C4C4C4",
    textAlign: "center",
    fontFamily: "Poppins",
    width: " 100%",
  },
  "& .weekData": {
    border: "1px solid #989696",
    borderRadius: "10px!important",
    gap: "10px!important",
    color: "#989696",
    textAlign: "center",
    padding: "11px 16px !important",
    fontSize: "14px",
    fontWeight: "400",
    margin: " 0px 6px 0px 0px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  "& .disabled.weekData.active ": {
    backgroundColor: "#dcd8ddb8",
    color: "#7b7373 !important",
    border: "1px solid #aaa !important",
    /* Add other styles for active state as needed */
  },
  "& .weekData.active ": {
    backgroundColor: "#BFE3FFB8",
    color: "#1F4970 !important",
    border: "1px solid #3E73A4 !important",
    /* Add other styles for active state as needed */
  },

  "& .delete-confirm-msg": {
    fontWeight: "400",
    fontSize: "20px",
    lineHeight: "24px",
    color: "#3E73A4",
    padding: "31px 0",
    fontFamily: "Poppins",
  },
  "& .deleteConfirmation": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflow: "auto",
    overflowX: "hidden",
  },
  "& .checkInConfirmation": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    minHeight: "300px",
    maxHeight: "90vh",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflow: "auto",
    overflowX: "hidden",
  },
  "& .deleteMedication": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflow: "auto",
    overflowX: "hidden",
  },
  "& .Add-medication": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflow: "auto",
    overflowX: "hidden",
  },

  "& .confirmModal": {
    zIndex: "9999",
    padding: "24px",
    backgroundColor: "#fff !important",
    borderRadius: "16px !important",
    maxWidth: "500px",
    width: "calc(100vw - 32px) !important",
    boxSizing: "border-box",
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1) !important",

    "& #modal-modal-title": {
      fontSize: "22px",
      fontWeight: "700",
      color: "#1F4970",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },

    "& .delete-confirm-msg": {
      fontSize: "16px",
      lineHeight: "1.6",
      color: "#3E73A4",
      padding: "20px 0",
      fontFamily: "Poppins",
      margin: 0,
    },
  },

  "& .create-training": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "15px",
    margin: "0px 10px",
    overflowY: "auto",
    maxHeight: "90vh",
    fontFamily: "Poppins",
    overflowX: "hidden",
  },

  "& input.file": {
    position: "relative",
    top: "-41px",
    left: "12%",
    opacity: "0",
  },
  "& .uploadPhoto": {
    width: "75px",
    height: "75px",
    margin: "auto",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "10px",
    boxShadow: "0px 0px 9px #ccc",
    marginTop: "7%",
  },
  "& .files": {
    fontFamily: "Poppins",
    fontWeight: "700",
    fontSize: "18px",
    lineHeight: "27px",
    textAlign: "center",
    color: "#465BBA",
    margin: "0",
  },
  "& .createPassword": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh",
    margin: "0px",
    width: "calc(100vw - 32px) !important",
    maxWidth: "782px",
    boxSizing: "border-box",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflowX: "hidden",
    overflowY: "auto",
  },
  "& .password-fields": {
    display: "grid",
    gap: "16px",
    gridTemplateColumns: "minmax(0, 1fr)",
    [theme.breakpoints.up("sm")]: {
      gap: "48px",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
  },
  "& .password-field": {
    minWidth: 0,
  },
  "& .confirm-msg": {
    color: "#1F4970",
    fontSize: "14px",
    fontWeight: "400",
    fontFamily: "Poppins",
    margin: " 10px",
  },
  "& .behavior": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh",
    margin: "0px 10px",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
  },
  "& .ManageZone": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflowY: "auto",
  },
  "& .generateUser": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflowY: "auto",
  },
  "& .createEvent": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh!important",
    margin: "0px 10px",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflowY: "auto",
  },
  "& .css-zikprk-MuiFormGroup-root": {
    padding: "0px 0px",
  },
  "& .cropper": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    // height: "458px",
    // maxHeight: "80vh",
    width: "50vw!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
  },
  "& .upload .MuiBox-root:nth-of-type(1)": {
    position: "relative !important",
    width: "100% !important",
    height: " auto !important",
    minHeight: "auto !important",
    maxHeight: "auto !important",
  },
  "& .normal-row": {
    cursor: "pointer !important",
  },
  "& .deleted-row": {
    opacity: "0.3 !important",
    cursor: "pointer !important",
  },
  "& svg": {
    cursor: "pointer",
  },
  "textarea.personal": {
    height: "200px !important",
    minHeight: " 200px !important",
    maxHeight: " 200px !important",
    overflow: "scroll",
  },
  "& .announcement": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflowY: "auto",
  },
  "& .alertAction": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh",
    width: "782px!important",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflowY: "auto",
  },
  "& .checkoutReason": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    minHeight: "300px",
    maxHeight: "90vh",
    width: "calc(100vw - 32px) !important",
    maxWidth: "500px",
    boxSizing: "border-box",
    margin: "0px",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflow: "auto",
    overflowX: "hidden",
  },

  // Keep every shared modal frame inside the viewport. Several dialog variants
  // previously combined a fixed 782px width with padding (and, in a few cases,
  // horizontal margins), which made the rendered box overflow compact screens.
  "& .createShift, & .deleteConfirmation, & .checkInConfirmation, & .deleteMedication, & .Add-medication, & .create-training, & .behavior, & .ManageZone, & .generateUser, & .createEvent, & .announcement & .alertAction":
    {
      width: "calc(100vw - 32px) !important",
      maxWidth: "782px",
      boxSizing: "border-box",
      margin: "0px",
    },
}));
